import React, { Component } from 'react';
import {Button, Flex, Picker, Radio, Stepper, WhiteSpace, WingBlank,List,InputItem,Toast} from 'antd-mobile';
import InputNumber from '../../../components/InputNumber';
import axios from 'axios';
import {ROOT_PATH} from '../../../config';
import send from '../../../utils/send';
import {FARM_ORG, ORG_CODE} from '../../../cache';
let guid = 0;
export default class SecondFarm extends Component {
  constructor (props) {
    super(props);
    this.state = {
      data: [],//地址数据源
      cost: true,
      farmNum: 1,
      farms: [{
        guid,
        cost: true,
        farmName: '',
        farmScale: '',
        address: []
      }]
    }
  }
  componentWillUnmount() {
    this.setState = () => false
  }
  async componentDidMount() {
    const address = await send(
      {
        url: `${ROOT_PATH}/api/ifarm/v180/address/list?parent_code=0`,
        method: 'GET'
      }
    );
    const resData = address.data.data;
    for (var i = 0; i < resData.length; i++) {
      var data = resData[i];
      data.label = data.name;
      data.value = JSON.stringify({name: data.name, code: data.code, lat: data.lat, lng: data.lng});
      for (var j = 0; j < data.children.length; j++) {
        var c1 = data.children[j];
        c1.label = c1.name;
        c1.value = JSON.stringify({name: c1.name, code: c1.code, lat: c1.lat, lng: c1.lng});
        for (var k = 0; k < c1.children.length; k++) {
          var c2 = c1.children[k];
          c2.label = c2.name;
          c2.value = JSON.stringify({name: c2.name, code: c2.code, lat: c2.lat, lng: c2.lng});
        }
      }
    }
    this.setState({
      data: resData
    });
    // 初始化第一个农场。
    const farmData = await send({
      url: '/api/forward/ifarm/simpleFarm/list',
      method: 'get'
    });
    const resData1 = farmData.data;
    const farms = resData1.map((o,index) => {
      guid = index;
      const gpsLocation = o.gpsLocation || '';
      //地址
      let addressData = gpsLocation.split(',');
      let address = [];
      if (addressData.length === 3) {
        //  符合地址要求，取值去。
        const province = resData.find(o => o.label === addressData[0]);
        const city = province.children.find(o =>o.label === addressData[1]);
        const town = city.children.find(o =>o.label === addressData[2]);
        const p = JSON.stringify({name: province.name, code: province.code, lat: province.lat, lng: province.lng});
        const c = JSON.stringify({name: city.name, code: city.code, lat: city.lat, lng: city.lng});
        const t = JSON.stringify({name: town.name, code: town.code, lat: town.lat, lng: town.lng});
        address.push(p,c,t);
      }
      const scale = o.project === 'PG'? o.capacityPiglet:o.capacity;
      return {
        guid,
        cost: true,
        farmName: o.nameLoc,
        farmScale: Number(scale || '0'),
        address
      }
    });
    console.log(farms);
    this.setState({
      farmNum: resData1.length,
      farms
    })
  }
  renderItem = (obj,index) => {
    const {farmName, farmScale, address, cost} = obj;
    console.log(obj);
    return <React.Fragment>
      {
        this.state.farmNum > 1 && <List.Item extra={<span style={{color:'#f00'}}
            onClick={()=>{
          this.setState(state => {
            state.farms.splice(index,1);
            state.farmNum = state.farms.length;
            return state;
          })
        }
        }
                                                    >删除</span>}
                                  >
          申请第 <b>{index + 1}</b> 个场
        </List.Item>
      }
      <InputItem className={'required text-right'}
          placeholder={'请输入'}
          maxLength={15}
          type={'text'}
          value={farmName}
          onChange={v => {
                   this.setState(state => {
                     state.farms[index].farmName = v;
                     return state;
                   })
                 }}
      >
        猪场名称
      </InputItem>
      <InputNumber className={'required text-right'}
          value={farmScale}
          precision={0}
          placeholder={'请输入'}
          onChange={(v) => {
                     let farmScale = v.substr(0,9);
                     this.setState(state => {
                       state.farms[index].farmScale = farmScale;
                       return state;
                     })
                   }}
      >
        猪场规模
      </InputNumber>
      <Picker extra="请选择"
          data={this.state.data}
          title="地址"
          value={address}
          onOk={(e) => {
                this.setState(state => {
                  state.farms[index].address = e;
                  return state;
                })
              }}
      >
        <List.Item  arrow={'horizontal'}
            className={(address.length=== 0) ? 'am-list-extra-empty span-4':'span-4'}
        >
          猪场地址
        </List.Item>
      </Picker>
      {
        false &&
        <List.Item className={'required span-3'}
            extra={
                     <Flex justify={'end'}>
                       <Radio className="my-radio"
                           style={{marginRight: 10}}
                           checked={cost}
                           onChange={() => {
                                this.setState(state => {
                                  state.farms[index].cost=true;
                                  return state;
                                })
                              }}
                       >需要</Radio>
                       <Radio className="my-radio"
                           checked={!cost}
                           onChange={() => {
                                this.setState(state => {
                                  state.farms[index].cost=false;
                                  return state;
                                })
                              }}
                       >不需要</Radio>
                     </Flex>
                   }
        >
          一起核算猪场成本
        </List.Item>
      }
    </React.Fragment>
  };
  doSaveCheck = () => {
    const {farms} = this.state;
    let err = 0;
    for (let i = 0; i < farms.length; i++) {
      let farm = farms[i];
      if (!farm.farmName) {
        err++;
        Toast.info(`请输入第${i + 1}个 猪场名称`,2);
        break
      }else if (farm.farmScale * 1 === 0){
        err++;
        Toast.info(`请输入第${i + 1}个 猪场规模`,3);
        break
      }else if (farm.address.length === 0){
        err++;
        Toast.info(`请输入第${i + 1}个 猪场地址`,3);
        break
      }
    }
    return err===0
  };
  doSave = () => {
    this.doSaveCheck() && this.saveData()
  };
  saveData = () => {
    // 有农场，未合作
    Toast.loading('提交中', 3);
    const {farms} = this.state;
    let data = farms.map(o => {
      let provinceName = '';
      let region_id = '';
      if (o.address.length > 0) {
        provinceName = JSON.parse(o.address[0]).name;
        region_id = JSON.parse(o.address[2]).code
      }
      return {
        farm_name: o.farmName,
        farm_code: FARM_ORG,
        org_name: o.farmName,
        org_code: ORG_CODE,
        company_name: provinceName + '养殖公司',
        company_code: ORG_CODE.substr(0,4),
        region_id,
        service_amount: o.farmScale
      }
    });
    send({
      url:'/api/ifarm/v180/farm/operation',
      method: 'post',
      data: {
        operation: data
      }
    }).then(res => {
      Toast.hide();
      if (res.data.statusCode === 200) {
        Toast.info('已经提交给参谋审核，请等待电话联系', 3)
      } else {
        Toast.info(res.data.message, 3)
      }
    })
  };
  render() {
    const {farmNum,farms} = this.state;
    return (
      <React.Fragment>
        <List.Item
            className={'required'}
            extra={
            <Stepper
                className={'stepper-round'}
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={1}
                value={farmNum}
                onChange={v => {
                guid++;
                const num = parseInt(v * 1);
                let farmData = farms;
                if (num > farmNum) {
                  console.log('add');
                  farmData = [...farms,{
                    guid,
                    cost: true,
                    farmName: '',
                    farmScale: '',
                    address: []
                  }]
                }else if (num < farmNum)  {
                  console.log('disc');
                  farmData.pop()
                } else {
                  console.log('相当')
                }
                console.log(farmData);
                this.setState({
                  farmNum: num || '',
                  farms: farmData
                })
              }}
            />}
        >
          申请合作猪场数量
        </List.Item>
        <div style={{height: 'calc(100vh - 60px)',overflowY: 'scroll'}}>
          {farms.map((o,index)=> {
            return <List renderHeader={() => ''}
                key={o.guid}
                   >
              {this.renderItem(o,index)}
            </List>
          })}
          <WingBlank size="lg">
            <WhiteSpace size={'lg'} />
            <Button type={'primary'}
                onClick={this.doSave}
            >完成</Button>
            <WhiteSpace size={'lg'} />
          </WingBlank>
        </div>


      </React.Fragment>
    )
  }
}
